import clsx from 'clsx'
import { ElementType, ReactNode } from 'react'
import LazySpinner from './spinners/LazySpinner'
import { ScaleLoader } from 'react-spinners'
import iconComponents from '@/assets/icons/iconComponents'
import Typography from './Typography'

type Props = {
  loadingComp?: ReactNode
  isLoading?: boolean
  children: ReactNode
  emptyComponent?: ReactNode
  isEmpty?: boolean
  className?: string
  as?: ElementType
}

const ApiState = (props: Props) => {
  const {
    className,
    isLoading,
    loadingComp,
    isEmpty,
    emptyComponent,
    children,
    as = 'div',
  } = props
  return (
    <Typography as={as} className={clsx('w-full flex-1 h-full', className)}>
      {isLoading
        ? loadingComp || (
            <LazySpinner show>
              <div className='w-full min-h-[50vh] h-full  bg-white rounded-lg flex justify-center items-center'>
                <ScaleLoader color='var(--mainprimary)' />
              </div>
            </LazySpinner>
          )
        : isEmpty
        ? emptyComponent || (
            <div className='w-full flex justify-center items-center gap-4 flex-col'>
              <iconComponents.util.EmptyMessageIcon />
              <Typography>No Resource Yet</Typography>
            </div>
          )
        : children}
    </Typography>
  )
}

export default ApiState
